import { createSlice } from "@reduxjs/toolkit";

const b2bContracts = createSlice({
  name: "b2bContracts",
  initialState: {
    contracts: [],
    economicGroups: [],
    planList: [],
    contactsFound: [],
    contract: {
      code: "",
      description: "",
      companyId: 0,
      startDate: "",
      endDate: "",
      active: true,
      contractPlans: [],
      contractContacts: [],
    },
    contractContactsNew: [],
    students: [],
    student: {},
  },
  reducers: {
    setContracts(state, { payload }) {
      state.contracts = payload;
    },
    setContract(state, { payload }) {
      state.contract = payload;
    },
    setStudents(state, { payload }) {
      state.students = payload;
    },
    setStudent(state, { payload }) {
      state.student = payload;
    },
    setContractContactsNew(state, { payload }) {
      state.contractContactsNew = payload;
    },
  },
});

export const { setContracts, setContract, setContractContactsNew, setStudents, setStudent } = b2bContracts.actions;

export default b2bContracts.reducer;
